import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import React from 'react';
import moment from 'moment';
import uuid from 'uuid/v4';
import { _InputWrapperDiv, StyledInlineDatePicker } from "./inputStyles";
import InputLabel from "./InputLabel";
import ErrorContainer from "./ErrorContainer";
import CalendarInputWrapper from "./CalendarInputWrapper";
export default function CalendarInput(_ref) {
  var disabled = _ref.disabled,
    input = _ref.input,
    inputId = _ref.inputId,
    _ref$inputValue = _ref.inputValue,
    inputValue = _ref$inputValue === void 0 ? '' : _ref$inputValue,
    labelText = _ref.labelText,
    noPadding = _ref.noPadding,
    onKeyDown = _ref.onKeyDown,
    required = _ref.required,
    name = _ref.name,
    maxDate = _ref.maxDate,
    minDate = _ref.minDate,
    error = _ref.error,
    initialFocusedDate = _ref.initialFocusedDate,
    highlight = _ref.highlight,
    onChange = _ref.onChange;
  var id = uuid();
  var onChangeDate = function onChangeDate(date) {
    if (input) {
      input.onChange(date);
    } else {
      onChange(name || inputId, date);
    }
  };
  var onChangeSearch = function onChangeSearch(day) {
    var formattedDay = day ? day.format('YYYY-MM-DD') : '';
    onChange(formattedDay);
  };
  var handleOnChange = inputId === 'search_deadline' ? onChangeSearch : onChangeDate;
  var value = inputValue ? moment(inputValue) : input !== null && input !== void 0 && input.value ? moment(input.value) : null;
  var wrapperClassName = [required ? 'required' : null, 'date-picker', value === null && required ? 'empty' : null].filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement(CalendarInputWrapper, {
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement(_InputWrapperDiv, null, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: id,
    labelText: labelText,
    required: required
  })), /*#__PURE__*/React.createElement(_InputWrapperDiv, {
    noPadding: noPadding
  }, /*#__PURE__*/React.createElement(StyledInlineDatePicker, {
    fullWidth: true,
    selectedDate: value,
    maxDate: maxDate !== undefined ? maxDate : new Date(),
    minDate: minDate,
    onChange: handleOnChange,
    name: name,
    disabled: disabled,
    onKeyDown: onKeyDown,
    initialFocusedDate: initialFocusedDate,
    id: id,
    highlight: highlight
  }), /*#__PURE__*/React.createElement(ErrorContainer, {
    error: error
  })));
}